import { render, staticRenderFns } from "./ProductsTitle.vue?vue&type=template&id=7d8aa134&lang=pug&"
import script from "./ProductsTitle.vue?vue&type=script&lang=js&"
export * from "./ProductsTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports